module.exports = __webpack_public_path__ + "img/icon-white-32.ddecf79f.svg";